<script lang="ts">
	import heroImageXs from "@assets/images/fathers-family-bag.jpg?webp&h=640&imagetools";
	import heroImageSm from "@assets/images/fathers-family-bag.jpg?webp&h=800&imagetools";
	import heroImageLg from "@assets/images/fathers-family-bag.jpg?webp&h=1100&imagetools";
	import heroImage2xl from "@assets/images/fathers-family-bag.jpg?webp&imagetools";
	import BuildYourSubscriptionButton from "@components/BuildYourSubscriptionButton.svelte";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import Link from "@components/common/Link.svelte";
	import Media from "@components/common/Media.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import { getHowItWorksAnchor } from "@core/schema/paths/getHowItWorksAnchor.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import AboutUsContentSection from "./AboutUsContentSection.svelte";
	import translations from "./FathersClubHeroSection.translations.json" with { type: "json" };

	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);
	const { priceFrom }: { priceFrom: string } = $props();
</script>

<AboutUsContentSection imageLeft={false} class="bg-fcrbeige !py-12 sm:!py-16 xl:!py-20" mediaClass="xl:w-150 xl:h-180">
	{#snippet heading()}
		<div class="flex flex-col">
			<div class="uppercase text-fcrorange font-bold tracking-[.1em]">
				<Formatted text={translate("section")} />
			</div>
			<Heading level={1} text={translate("title", { price: priceFrom })} class="heading-1 text-fcrdarkgray mt-4" />
		</div>
	{/snippet}
	<p class="text-5/tighter max-w-120">
		<Formatted text={translate("description")} />
	</p>
	<div class="mt-8 flex flex-col sm:flex-row flex-wrap gap-3">
		<BuildYourSubscriptionButton variant={ButtonVariant.Dark} registerLabel />
		<Link href={getHowItWorksAnchor(tenant.locale)} size={ButtonSize.Medium} variant={ButtonVariant.White}>
			<Formatted text={translate("howItWorks")} />
		</Link>
	</div>
	{#snippet media()}
		<Media
			eager
			preload="high"
			width={488}
			height={640}
			source={{ type: "image/webp", src: heroImageXs }}
			sourcesets={{
				">sm": heroImageSm,
				">lg": heroImageLg,
				">2xl": heroImage2xl,
			}}
			alt={translate("imageAlt")}
			class="size-full object-cover"
			wrapperClass="absolute inset-0"
		/>
	{/snippet}
</AboutUsContentSection>
